/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import Portrait from 'gatsby-matrix-theme/src/components/molecules/header/variants/author/assets/portrait';
import Name from 'gatsby-matrix-theme/src/components/molecules/header/variants/author/assets/name';
import Socials from 'gatsby-matrix-theme/src/components/atoms/author/socials';
import Expertise from 'gatsby-matrix-theme/src/components/molecules/header/variants/author/assets/expertise';
import Ribbon from 'gatsby-matrix-theme/src/components/molecules/header/variants/author/assets/ribbon';
import useTranslate from '~hooks/useTranslate/useTranslate';
import styles from './template-one.module.scss';

export default function TemplateOne({ author, icons, authorTitle }) {
  const {
    pages_count: pagesCount,
    author_title: jobTitle,
    name,
    biography,
    expertise,
    pronouns,
  } = author || null;

  return (
    <div className={styles?.container || ''}>
      <Ribbon
        className={styles?.posts || ''}
        author={author}
        content={`${pagesCount} ${useTranslate('posts', 'Posts')}`}
      />
      <div className={styles.authorInfo}>
        <Portrait className={styles?.portrait || ''} author={author} />
        <div>
          <Name
            className={styles?.name || ''}
            name={authorTitle || name}
            icon={icons?.verify}
            pronouns={pronouns || ''}
          />
          {jobTitle && <div className={styles?.title || ''}>{jobTitle}</div>}
          <Socials className={styles?.socials || ''} author={author} />
          <Expertise className={styles.expertise} expertise={expertise} icon={icons?.expertise} />
        </div>
      </div>
      {biography && (
        <div
          className={styles?.biography || ''}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: biography }}
        />
      )}
    </div>
  );
}

TemplateOne.propTypes = {
  authorTitle: PropTypes.string,
  author: PropTypes.shape({
    name: PropTypes.string,
    pages_count: PropTypes.number,
    author_title: PropTypes.string,
    biography: PropTypes.string,
    image_alt: PropTypes.string,
    expertise: PropTypes.array,
    icon: PropTypes.object,
    profile_page_path: PropTypes.string,
    facebook_profile: PropTypes.string,
    instagram_profile: PropTypes.string,
    linkedin_profile: PropTypes.string,
    twitter_profile: PropTypes.string,
    tik_tok: PropTypes.string,
    image_object: PropTypes.shape({
      filename: PropTypes.string,
    }),
  }),
  icons: PropTypes.object,
};
